import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
export function Welcome() {
  const navigate = useNavigate();
  return <div className="w-full h-full bg-black flex flex-col relative overflow-hidden" data-id="element-789">
      {/* Hero Photo Area */}
      <div className="flex-1 relative overflow-hidden" data-id="element-790">
        <motion.img initial={{
        scale: 1.1
      }} animate={{
        scale: 1
      }} transition={{
        duration: 6,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/9YMPWmsn6iGK1o4o9AixXJ/ChatGPT_Image_May_12,_2026,_09_26_47_PM.png" alt="Multicultural group of people with happy faces" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-791" />

        {/* Subtle overlay — lighter at top to show faces, darker toward bottom for legibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/70" data-id="element-792" />
        <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/60 to-transparent" data-id="element-793" />

        {/* Yellow accent glow */}
        <div className="absolute top-1/3 -right-12 w-48 h-48 bg-primary/30 rounded-full blur-3xl mix-blend-screen" data-id="element-794" />
      </div>

      {/* Content & Actions */}
      <div className="bg-surface rounded-t-[40px] px-6 pt-10 pb-12 flex flex-col items-center z-20 shadow-[0_-10px_40px_rgba(0,0,0,0.5)] -mt-10 relative" data-id="element-795">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-center mb-8" data-id="element-796">
          <h1 className="text-3xl font-poppins font-bold text-white mb-3" data-id="element-797">
            Watch & Share
            <br data-id="element-798" />
            Funny Videos
          </h1>
          <p className="text-softGray text-sm px-4" data-id="element-799">
            Join the biggest comedy club on the internet. Endless laughs await.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="w-full flex flex-col gap-3" data-id="element-800">
          <Button fullWidth onClick={() => navigate('/auth/role')} data-id="element-801">
            Sign Up
          </Button>
          <Button variant="outline" fullWidth onClick={() => navigate('/auth/login')} data-id="element-802">
            Login
          </Button>
          <Button variant="ghost" fullWidth onClick={() => navigate('/feed')} className="text-softGray mt-2" data-id="element-803">
            Continue as Guest
          </Button>
        </motion.div>
      </div>
    </div>;
}